module.exports = __webpack_public_path__ + "img/6.5edbbd9a.png";